/** One CaseBlink starter in the Case Automations Explore section. */
import { Play } from "lucide-react";
import type { FC } from "react";

import { Surface } from "@/components/surface";
import { Button } from "@/components/ui/button";
import { IconTile } from "@/components/ui/icon-tile";
import type { StarterSkill } from "@/features/automations/components/skillModel";

type Props = {
  starter: StarterSkill;
  onRun: (starter: StarterSkill) => void;
};

export const ExploreStarterCard: FC<Props> = ({ starter, onRun }) => {
  const Icon = starter.icon;
  return (
    <Surface
      className="gap-2 p-3 ring-line-3"
      data-testid={`explore-starter-${starter.id}`}
    >
      <div className="flex items-center gap-2.5">
        <IconTile icon={Icon} />
        <span className="truncate text-md font-medium text-fg">
          {starter.title}
        </span>
      </div>
      <p className="line-clamp-2 text-base text-fg-2">{starter.blurb}</p>
      <p className="text-sm text-fg-2">
        <span className="font-medium text-fg">{starter.when}</span>
        <span aria-hidden> · </span>
        <span>{starter.makes}</span>
      </p>
      <div className="mt-auto flex items-center justify-end">
        <Button
          variant="secondary"
          size="sm"
          onClick={() => onRun(starter)}
          data-testid="explore-starter-run"
        >
          <Play />
          Run
        </Button>
      </div>
    </Surface>
  );
};
